<template>
  <rpm-input
    type="textarea"
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
    class="w-full"
  ></rpm-input>
</template>

<script>
export default {
  name: "TextareaAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
};
</script>
